// extracted by mini-css-extract-plugin
module.exports = {"Back":"InsuranceDevice_Back__fmnMr"};